import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Route, Switch } from 'react-router-dom'

import Donate from 'portals/widgets/components/widgets/Donate'
import Payment from 'portals/widgets/components/widgets/Payment'
import SubscribeForm from 'portals/widgets/components/widgets/Subscribe'

import { isLoggedIn, loggedInUser } from 'actions/auth'

class WidgetsRouter extends Component {

    componentDidUpdate(prevProps) {
        const { is_logged_in, history, has_usable_password, is_superuser } = this.props
        if (!prevProps.is_logged_in && is_logged_in) {
            if (is_superuser) {
                history.push('/widgets')
            } else {
                history.push('/')
            }
        }
        if (prevProps.is_logged_in && !is_logged_in) {
            history.push('/')
        }
    }

    render() {
        const { is_logged_in, is_superuser } = this.props
        if ( ! is_logged_in ) {
            return (
              <div>
                <Switch>
                  <Route path="/widgets/subscribe" exact={ true } component={ SubscribeForm } />
                  <Route path="/widgets/donate" exact={ true } component={ Donate } />
                  <Route path="/payment/:status/:id" exact={ true } component={ Payment } />
                  <Route path="/donate/:id" exact={ true } component={ Donate } />
                  <Route path="/donate" exact={ true } component={ Donate } />
                  <Route path="/widgets/" exact={ true } component={ Donate } />
                </Switch>
              </div>
            )
        }

        return (
            <div>
              <Switch>
                <Route path="/widgets/subscribe" exact={ true } component={ SubscribeForm } />
                <Route path="/widgets/donate" exact={ true } component={ Donate } />
                <Route path="/payment/:status/:id" exact={ true } component={ Payment } />
                <Route path="/donate/:id" exact={ true } component={ Donate } />
                <Route path="/donate" exact={ true } component={ Donate } />
                <Route path="/widgets/" exact={ false } component={ Donate } />
              </Switch>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const is_logged_in = isLoggedIn()
    let has_usable_password = true
    let is_superuser = false
    if (is_logged_in) {
        const user = loggedInUser()
        has_usable_password = user && user['has_usable_password']
        is_superuser = user && user['is_superuser']
    }
    return {
        is_logged_in: is_logged_in,
        has_usable_password: has_usable_password,
        is_superuser: is_superuser
    }
}
export default withRouter(connect(mapStateToProps)(WidgetsRouter))
